// 开票相关页面

const ApplyInvoice = r => require.ensure(
  [],
  () => r(require('@/components/invoice-about/apply-invoice')),
  'ApplyInvoice'
)
const SendEmail = r => require.ensure(
  [],
  () => r(require('@/components/invoice-about/send-email')),
  'SendEmail'
)

export default [
  {
    path: '/ApplyInvoice/:taskRelationId/:orderId',
    name: 'ApplyInvoice',
    component: ApplyInvoice
  },
  {
    path: '/SendEmail/:taskRelationId/:businessId/:invoiceId/:email',
    name: 'SendEmail',
    component: SendEmail
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/invoice-about.js